import store from '../../store/index'
import departmentSettingsSelectors from "../../store/department-settings/selectors";

const formatRoleName = role =>
  ({
    admin: 'App Admin',
    depadmin: 'Department Admin',
    cstaff: departmentSettingsSelectors.cstaffLabel(store.getState()),
    chief: departmentSettingsSelectors.chiefLabel(store.getState()),
    ftoc: departmentSettingsSelectors.ftocLabel(store.getState()),
    fto: departmentSettingsSelectors.ftoLabel(store.getState()),
    sup: departmentSettingsSelectors.supLabel(store.getState()),
    oit: departmentSettingsSelectors.oitLabel(store.getState()),
  }[role]);

export default formatRoleName;
